export default {
    name: '作業依頼内容名称',
    sortno: '並び順'
};
